module.exports = __webpack_public_path__ + "img/docicon.4345f14b.svg";